<template>
  <section class="terms">
    <h2>개인정보 제공 동의<span class="text--required">(필수)</span></h2>
    <ol>
      <li>
        <span class="label">1.</span>
        제공 받는 자 :  <b class="fs-md">{{ name }}</b>
      </li>
      <li>
        <span class="label">2.</span>
        제공받는 자의 이용목적 : <b class="fs-md">주문한 상품의 주문처리, 거래이행, 배송, 고객상담 등불만처리</b>
      </li>
      <li>
        <span class="label">3.</span>
        제공하는 개인정보 항목 : 이름, 휴대전화번호, 배송지정보
      </li>
      <li>
        <span class="label">4.</span>
        제공받는 자의 개인정보 보유기간 : <b class="fs-md">제공받는 자의 이용 목적 달성 시 까지</b>
      </li>
    </ol>
    <ol>
      <li>
      <span class="label">*</span>개인정보 제공은 서비스 이용을 위해 꼭 필요합니다. 제공에 동의하지 않을 수 있으나, 동의하지 않으면 서비스 이용이 제한 됩니다.
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  props : {
    name:String
  }
}
</script>

<style scoped>

</style>
